import { checkShouldUseMocks } from '@telialt/utils/src/envUtils';
import { isSSR } from '@telialt/utils/src/helpers';
import { getIsUserAuthorized } from '@telialt/utils/src/SSO/utils';

export const API = {
    URL_PRODUCT_METADATA: '/rest/v2/{siteName}/metadata?pageType=PRODUCT&url={productUrl}',
    URL_IS_LOCAL_ENV: '/rest/v2/{siteName}/me/info',
    URL_PRODUCT: '/rest/v2/{siteName}/products/{productCode}',
    URL_PRODUCT_REFERENCES: '/rest/v2/{siteName}/products/{productCode}/references',
    URL_BANKS: '/rest/v2/{siteName}/banks',
    URL_AUTH_SESSION_PROLONGATION: '/ajax/session/prolongation',
    /* CART ENDPOINTS*/
    URL_CREATE_CART: '/rest/v2/{siteName}/users/{userId}/carts?fields=FULL',
    URL_MIGRATE_CART: '/rest/v2/{siteName}/users/{userId}/carts',
    URL_GET_CART: '/rest/v2/{siteName}/users/{userId}/carts/{cartId}',
    URL_CLONE_CART: '/rest/v2/{siteName}/users/{userId}/carts/{cartId}/clone?fields=FULL',
    URL_ADD_CART_ENTRY: '/rest/v2/{siteName}/users/{userId}/carts/{cartId}/entries',
    URL_REMOVE_CART_ENTRY: '/rest/v2/{siteName}/users/{userId}/carts/{cartId}/entries/{entryNumber}?fields=FULL',
    URL_DELETE_CART: '/rest/v2/{siteName}/users/{userId}/carts/{cartId}', // NOTE: not used
    URL_UPDATE_CART_INSURANCE: '/rest/v2/{siteName}/users/{userId}/carts/{cartId}/insurance?fields=FULL',
    URL_UPDATE_CART_NETFLIX: '/rest/v2/{siteName}/users/{userId}/carts/{cartId}/netflix',
    URL_UPDATE_CART_DISNEY: '/rest/v2/{siteName}/users/{userId}/carts/{cartId}/disney',
    URL_UPDATE_INITIAL_PAYMENT_AMOUNT: '/rest/v2/{siteName}/users/{userId}/carts/{cartId}/initial-payment',
    URL_ADD_GIFTS: '/rest/v2/{siteName}/users/{userId}/carts/{cartId}/gifts?fields=FULL',
    URL_COUPONS: '/rest/v2/{siteName}/users/{userId}/carts/{cartId}/coupons',
    URL_PLACE_ORDER: '/rest/v2/{siteName}/users/{userId}/orders',
    URL_CANCEL_ORDER: '/rest/v2/{siteName}/users/{userId}/orders/{orderId}/cancel',
    URL_INITIATE_BANKLINK_PAYMENT: '/rest/v2/{siteName}/users/{userId}/carts/{cartId}/banklink-payment',
    URL_INITIATE_POP_PAYMENT: '/rest/v2/{siteName}/users/{userId}/carts/{cartId}/pop-payment',
    URL_REGISTER_CART_STEP: '/rest/v2/{siteName}/users/{userId}/carts/{cartId}/steps',
    URL_REGISTER_ABSTRACT_ORDER_STEP: '/rest/v2/{siteName}/users/{userId}/abstractorders/{cartId}/steps',
    URL_SET_ADDRESSES: '/rest/v2/{siteName}/users/{userId}/carts/{cartId}/addresses/combined',
    URL_CHECKOUT_CREDIT_CHECK: '/rest/v2/{siteName}/users/{userId}/carts/{cartCode}/credit-check',
    URL_SET_SELECTED_PLAN_ORDER: '/rest/v2/{siteName}/users/{userId}/carts/{cartCode}/contract-option',
    URL_GET_TELCO_OPERATORS: '/rest/v2/{siteName}/telco-operators',
    URL_ADD_RATE_PLAN: '/rest/v2/{siteName}/users/{userId}/carts/{cartId}/rate-plans/{ratePlanCode}',
    URL_RATE_PLAN: '/rest/v2/{siteName}/users/{userId}/carts/{cartId}/rate-plans',
    URL_ADD_LEASING_PLAN: '/rest/v2/{siteName}/users/{userId}/carts/{cartId}/leasing-plans/{leasingPlanCode}',
    URL_LEASING_PLAN: '/rest/v2/{siteName}/users/{userId}/carts/{cartId}/leasing-plans',
    URL_GET_DELIVERY_MODES: '/rest/v2/{siteName}/deliverymodes',
    URL_SET_DELIVERY_MODE: '/rest/v2/{siteName}/users/{userId}/carts/{cartId}/deliverymode',
    URL_GET_ORDER: '/rest/v2/{siteName}/users/{userId}/orders/{cartId}',
    URL_POST_CONFIRMATION_PLACE_ORDER: '/rest/v2/{siteName}/users/{userId}/payments/{cartId}/placeOrder',
    URL_GET_CREDIT_CHECK_TEXT: '/view/FaqCMSComponentController/answer?id=mokumo-ir-kreditingumo-vertimas',
    URL_GET_TERMS_OF_USE_TEXT: '/rest/v2/{siteName}/users/anonymous/consenttemplates/{code}',
    URL_GET_IS_ELIGIBLE_TO_APPLY_DISCOUNT:
        '/rest/v2/{siteName}/users/{userId}/carts/{cartId}/discount-exceeds-price/{couponCode}',
    URL_UPDATE_CONTRACT_TYPE: '/rest/v2/{siteName}/users/{userId}/carts/{cartId}/contract-type?fields=FULL',
    URL_UPDATE_RENTING_PLAN:
        '/rest/v2/{siteName}/users/{userId}/carts/{cartId}/renting-plans/{rentingPeriod}?fields=FULL',
    URL_SET_COMPANY_INFO: '/rest/v2/{siteName}/users/{userId}/carts/{cartId}/b2b-company-info',
    URL_SET_VAT_CONFIG_DEFAULTS: '/rest/v2/{siteName}/users/{userId}/carts/{cartId}/vat-config/initiate-defaults',
    URL_SET_VAT_CONFIG_BUDGETARY_INSTITUTION:
        '/rest/v2/{siteName}/users/{userId}/carts/{cartId}/vat-config/budgetary-institution',
    URL_SET_VAT_CONFIG_REGISTERED_VAT_PAYER:
        '/rest/v2/{siteName}/users/{userId}/carts/{cartId}/vat-config/registered-vat-payer',
    URL_SAVE_NAME: '/rest/v2/{siteName}/users/{userId}',
    URL_UPDATE_CARD_TYPE: '/rest/v2/{siteName}/users/{userId}/carts/{cartId}/change-card',
    URL_MARK_ORDER_AS_PAID_IN_CRM: '/rest/v2/{siteName}/users/{userId}/orders/{cartId}/payment',
    URL_GET_CONSENT_TEMPLATE: '/rest/v2/{siteName}/users/{userId}/consents/templates/{consentTemplateType}',
    URL_GET_ORDER_DOCUMENT: '/rest/v2/{siteName}/users/{userId}/orders/{cartId}/documents/{documentId}',
    URL_GET_SODRA_DOCUMENT: '/rest/v2/{siteName}/users/{userId}/orders/{cartId}/sodra',
    URL_GET_SODRA_CREDIT_CHECK_STATUS: '/rest/v2/{siteName}/users/{userId}/orders/{cartId}',
    URL_ALL_SUBSCRIPTIONS: '/api/v1/{segment}/my/accounts/subscriptions',
};

if (checkShouldUseMocks()) {
    API.URL_PRODUCT_METADATA = '/api/eshop/product-metadata';
    API.URL_PRODUCT = '/api/eshop-product/product/{productCode}';
    API.URL_PRODUCT_REFERENCES = '/api/eshop/product-references?productCode={productCode}';
    API.URL_LEASING_PLAN = '/api/eshop/product-leasing-plans?productCode={productCode}';
    API.URL_BANKS = '/api/eshop/banks';

    /* CART ENDPOINTS*/
    API.URL_CREATE_CART = '/api/eshop/cart-create';
    API.URL_CLONE_CART = '/api/eshop/cart';
    API.URL_MIGRATE_CART =
        !isSSR() && getIsUserAuthorized()
            ? '/api/eshop/cart-logged-in?oldCartId={oldCartId}'
            : '/api/eshop/cart?oldCartId={oldCartId}';
    API.URL_GET_CART =
        !isSSR() && getIsUserAuthorized()
            ? '/api/eshop/cart-logged-in?cartId={cartId}&userId={userId}'
            : '/api/eshop/cart?cartId={cartId}';
    API.URL_ADD_CART_ENTRY = '/api/eshop/add-to-cart-response?userId={userId}&cartId={cartId}';
    API.URL_REMOVE_CART_ENTRY =
        '/api/eshop/remove-from-cart-response?userId={userId}&cartId={cartId}&entryNumber={entryNumber}';
    API.URL_UPDATE_CART_INSURANCE = '/api/eshop/cart-insurance?cartId={cartId}';
    API.URL_UPDATE_CART_NETFLIX = !isSSR() && getIsUserAuthorized() ? '/api/eshop/cart-logged-in' : '/api/eshop/cart';
    API.URL_UPDATE_CART_DISNEY = !isSSR() && getIsUserAuthorized() ? '/api/eshop/cart-logged-in' : '/api/eshop/cart';
    API.URL_UPDATE_INITIAL_PAYMENT_AMOUNT = '/api/eshop/cart?cartId={cartId}';
    API.URL_ADD_GIFTS = '/api/eshop/add-gifts-response?userId={userId}&cartId={cartId}';
    API.URL_COUPONS = '/api/eshop/submit-coupon-response?userId={userId}&cartId={cartId}';
    API.URL_PLACE_ORDER = '/api/eshop/order-place';
    API.URL_CANCEL_ORDER = '/api/eshop/orders';
    API.URL_INITIATE_BANKLINK_PAYMENT = '/api/eshop/banklink-payment';
    API.URL_INITIATE_POP_PAYMENT = '/api/eshop/pop-payment';
    API.URL_REGISTER_CART_STEP = '/api/eshop/steps?userId={userId}&cartId={cartId}';
    API.URL_REGISTER_ABSTRACT_ORDER_STEP = '/api/eshop/steps?userId={userId}&cartId={cartId}';
    API.URL_SET_ADDRESSES = '/api/eshop/set-combined-addresses';
    API.URL_CHECKOUT_CREDIT_CHECK = '/api/eshop/credit-check?userId={userId}&cartCode={cartCode}';
    API.URL_SET_SELECTED_PLAN_ORDER =
        !isSSR() && getIsUserAuthorized()
            ? '/api/eshop/cart-logged-in?action=contract-option&userId={userId}&cartCode={cartCode}'
            : '/api/eshop/cart?action=contract-option&userId={userId}&cartCode={cartCode}';
    API.URL_GET_TELCO_OPERATORS = '/api/eshop/telco-operators';
    API.URL_GET_DELIVERY_MODES = '/api/eshop/delivery-modes';
    API.URL_SET_DELIVERY_MODE = '/api/eshop/set-delivery-mode';
    API.URL_GET_ORDER = '/api/eshop/order?cartId={cartId}';
    API.URL_POST_CONFIRMATION_PLACE_ORDER = '/api/eshop/order?cartId={cartId}';
    API.URL_GET_CREDIT_CHECK_TEXT = '/api/eshop/credit-check-text';
    API.URL_GET_TERMS_OF_USE_TEXT = '/api/eshop/terms-of-use';
    API.URL_ADD_RATE_PLAN = '/api/eshop/add-rate-plan-response';
    API.URL_UPDATE_CONTRACT_TYPE = '/api/eshop/update-contract-type';
    API.URL_MARK_ORDER_AS_PAID_IN_CRM = '/api/eshop/order';
    API.URL_SAVE_NAME = '/api/eshop/checkout/save-name';
    API.URL_GET_CONSENT_TEMPLATE = '/api/eshop/consent-template';
    API.URL_GET_ORDER_DOCUMENT = '/api/eshop/checkout/document';
    API.URL_GET_SODRA_DOCUMENT = '/api/eshop/checkout/sodra?userId={userId}&cartId={cartId}';
    API.URL_GET_SODRA_CREDIT_CHECK_STATUS = '/api/eshop/checkout/sodra-credit-check';
    API.URL_ALL_SUBSCRIPTIONS = '/api/self-service/subscriptions/all';
    API.URL_SET_VAT_CONFIG_DEFAULTS =
        !isSSR() && getIsUserAuthorized()
            ? '/api/eshop/cart-logged-in?action=initiate-defaults&userId={userId}&cartId={cartId}'
            : '/api/eshop/cart?action=initiate-defaults&userId={userId}&cartId={cartId}';
    API.URL_SET_COMPANY_INFO =
        !isSSR() && getIsUserAuthorized()
            ? '/api/eshop/cart-logged-in?action=set-company-info&userId={userId}&cartId={cartId}'
            : '/api/eshop/cart?action=set-company-info&userId={userId}&cartId={cartId}';
}
